module.exports = __webpack_public_path__ + "static/customer-journey-map-future-state-ccfd9db235c3c901dc9477712867fb23.jpg";